var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfoGen = function SvgIconInfoGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.501,
    r: 6.667,
    fill: "#616879"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2FA",
    fillRule: "evenodd",
    d: "M18.834 10.5a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0M10.5 9.665c.46 0 .834.373.834.833v4.168a.833.833 0 0 1-1.667 0v-4.168c0-.46.373-.833.833-.833m0-1.667a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666",
    clipRule: "evenodd"
  })));
};
export default SvgIconInfoGen;